<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<!-- <a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button> -->
				<a-button icon="sync" @click="apiStaffQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="员工查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属企业：</div>
						<a-select v-model="query.enterpriseId" style="width: 100%;">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option v-for="(item,index) in enterpriseList" :value="item.enterpriseId" :key="index">{{item.enterpriseName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">员工名称：</div>
						<a-input v-model="query.staffName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiStaffQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="staffId" :loading="tableLoading" :pagination="false">
				<span slot="enterpriseId" slot-scope="enterpriseId">
					{{ enterpriseList.find(item => item.enterpriseId == enterpriseId)?enterpriseList.find(item => item.enterpriseId == enterpriseId).enterpriseName:'-' }}
				</span>
				<!-- <span slot="departmentName" slot-scope="departmentName">
					<a-button type="link" @click="edit(departmentName)" >{{departmentName.departmentName}}</a-button>
				</span> -->
				<span slot="staffState" slot-scope="staffState">
					<span v-if="staffState == 2">禁用</span>
					<span v-if="staffState == 3">启用</span>
				</span>
				
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<a-divider>登录信息</a-divider>
						<div class="qa-table-item-3">
							<a-form-model-item label="登录账号" has-feedback prop="staffAccount">
								<a-input v-model="addForm.staffAccount" />
							</a-form-model-item>
							<a-form-model-item label="登录密码" has-feedback prop="staffPwd">
								<a-input v-model="addForm.staffPwd" />
							</a-form-model-item>
							<a-form-model-item label="是否启用" has-feedback prop="staffState">
								<a-radio-group name="staffState" v-model="addForm.staffState">
									<a-radio :value="3">是</a-radio>
									<a-radio :value="2">否</a-radio>
								</a-radio-group>
							</a-form-model-item>
		
						</div>
					<a-divider>基本信息</a-divider>
						<div class="qa-table-item-3">
							<a-form-model-item label="员工姓名" has-feedback prop="staffName">
								<a-input v-model="addForm.staffName" />
							</a-form-model-item>
							<a-form-model-item label="性别" has-feedback prop="gender">
								<a-radio-group name="gender" v-model="addForm.gender">
									<a-radio :value="2">男</a-radio>
									<a-radio :value="3">女</a-radio>
								</a-radio-group>
							</a-form-model-item>
							<a-form-model-item label="出生日期" has-feedback prop="birthday">
								<a-date-picker @change="birthdayAddChange" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="身份证号" has-feedback prop="idcard">
								<a-input v-model="addForm.idcard" />
							</a-form-model-item>
							<a-form-model-item label="联系电话" has-feedback prop="phone">
								<a-input v-model="addForm.phone" />
							</a-form-model-item>
							<a-form-model-item >
								
							</a-form-model-item>
						</div>
					<a-divider>入职信息</a-divider>
						<div class="qa-table-item-2">
							<a-form-model-item label="所属企业" has-feedback prop="enterpriseId">
								<a-select v-model="addForm.enterpriseId" @change="enterpriseChange">
									<a-select-option :value="0">请选择</a-select-option>
									<a-select-option v-for="(item,index) in enterpriseList" :value="item.enterpriseId" :key="index">{{item.enterpriseName}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="部门" has-feedback prop="departmentId">
								<a-select v-model="addForm.departmentId" @change="departmentChange">
									<a-select-option :value="0">请选择</a-select-option>
									<a-select-option v-for="(item,index) in departmentList" :value="item.departmentId" :key="index">{{item.departmentName}}</a-select-option>
								</a-select>
							</a-form-model-item>
							<a-form-model-item label="入职时间" has-feedback prop="entryTime">
								<a-date-picker @change="entryTimeAddChange" />
							</a-form-model-item>
							<a-form-model-item >
							</a-form-model-item>
						</div>
						
						<a-form-model-item label="对应职位" has-feedback prop="positions" v-if="positionsList.length > 0">
							<a-checkbox-group :options="positionsList"   v-model="addForm.positions"/>
						</a-form-model-item>
						<div class="qa-table-item-1">
							<a-form-model-item label="备注" has-feedback prop="remarks">
								<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
							</a-form-model-item>
						</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<a-divider>登录信息</a-divider>
						<div class="qa-table-item-3">
							<a-form-model-item label="登录账号" has-feedback prop="staffAccount">
								<a-input v-model="editForm.staffAccount" disabled />
							</a-form-model-item>
							<a-form-model-item label="是否启用" has-feedback prop="staffState">
								<a-radio-group name="staffState" v-model="editForm.staffState">
									<a-radio :value="3">是</a-radio>
									<a-radio :value="2">否</a-radio>
								</a-radio-group>
							</a-form-model-item>
							<a-form-model-item >
							</a-form-model-item>
						</div>
					<a-divider>基本信息</a-divider>
						<div class="qa-table-item-3">
							<a-form-model-item label="员工姓名" has-feedback prop="staffName">
								<a-input v-model="editForm.staffName" />
							</a-form-model-item>
							<a-form-model-item label="性别" has-feedback prop="gender">
								<a-radio-group name="gender" v-model="editForm.gender">
									<a-radio :value="2">男</a-radio>
									<a-radio :value="3">女</a-radio>
								</a-radio-group>
							</a-form-model-item>
							<a-form-model-item label="出生日期" has-feedback prop="birthday">
								<a-date-picker v-model="editForm.birthday" @change="birthdayEditChange" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="身份证号" has-feedback prop="idcard">
								<a-input v-model="editForm.idcard" />
							</a-form-model-item>
							<a-form-model-item label="联系电话" has-feedback prop="phone">
								<a-input v-model="editForm.phone" />
							</a-form-model-item>
							<a-form-model-item >
							</a-form-model-item>
						</div>
					<a-divider>入职信息</a-divider>
						<div class="qa-table-item-2">
							<a-form-model-item label="所属企业" has-feedback prop="enterpriseId">
								<a-select v-model="editForm.enterpriseId" @change="enterpriseChange">
									<a-select-option :value="0">请选择</a-select-option>
									<a-select-option v-for="(item,index) in enterpriseList" :value="item.enterpriseId" :key="index">{{item.enterpriseName}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="部门" has-feedback prop="departmentId">
								<a-select v-model="editForm.departmentId" @change="departmentChange">
									<a-select-option :value="0">请选择</a-select-option>
									<a-select-option v-for="(item,index) in departmentList" :value="item.departmentId" :key="index">{{item.departmentName}}</a-select-option>
								</a-select>
							</a-form-model-item>
							<a-form-model-item label="入职时间" has-feedback prop="entryTime">
								<a-date-picker v-model="editForm.entryTime" @change="entryTimeEditChange" />
							</a-form-model-item>
							<a-form-model-item >
							</a-form-model-item>
						</div>
						
						<a-form-model-item label="对应职位" has-feedback prop="positions" v-if="positionsList.length > 0">
							<a-checkbox-group :options="positionsList"   v-model="editForm.positions"/>
						</a-form-model-item>
						<div class="qa-table-item-1">
							<a-form-model-item label="备注" has-feedback prop="remarks">
								<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
							</a-form-model-item>
						</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
					
				</a-form-model>
			</div>
			
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				enterpriseList: [],
				departmentList: [],
				positionsList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					departmentId: 0,
					enterpriseId: 0,
					staffName: '',
				},
				tableData: [],
				tableColumns: [{
						title: '员工ID',
						dataIndex: 'staffId',
						key: 'staffId',
						align: 'center'
					},
					{
						title: '登录账号',
						dataIndex: 'staffAccount',
						key: 'staffAccount',
						align: 'center',
					},
					{
						title: '员工姓名',
						dataIndex: 'staffName',
						key: 'staffName',
						align: 'center',
					},
					{
						title: '所属企业',
						dataIndex: 'enterpriseId',
						key: 'enterpriseId',
						align: 'center',
						scopedSlots: {
							customRender: 'enterpriseId'
						}
					},
		
					{
						title: '状态',
						dataIndex: 'staffState',
						key: 'staffState',
						align: 'center',
						scopedSlots: {
							customRender: 'staffState'
						}
					},
					{
						title: '备注',
						dataIndex: 'remarks',
						key: 'remarks',
						align: 'center',
					}
	

				],
				tableLoading: false,
				tableSelectedRows: {},
				selectedRowKeys: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					staffAccount: '',
					staffPwd: '',
					staffState: 3,
					staffName: '',
					gender: 2,
					birthday: '',
					idcard: '',
					phone: '',
					enterpriseId: 0,
					departmentId: 0,
					entryTime: '',
					positions: [],
					remarks: '',
					
				},
				addRules: {
					// enterpriseId: [{ required: true, type: 'number', min: 1, message: '请选择企业', trigger: 'blur' }],
					// departmentName: [{ required: true, message: '员工名称不能为空', trigger: 'blur' }],

				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					staffId: '',
					staffAccount: '',
					staffState: 3,
					staffName: '',
					gender: 2,
					birthday: '',
					idcard: '',
					phone: '',
					enterpriseId: 0,
					departmentId: 0,
					entryTime: '',
					positions: [],
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取企业列表
			async apiEnterpriseList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseList,this.query);
				if (res.code == 200) {
					this.enterpriseList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取职位列表
			async apiPositionsList(departmentId) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPositionsList,{departmentId});
				if (res.code == 200) {
					// 用新数组替换，保证响应式更新
					this.positionsList = res.data.map(item => ({ label: item.positionsName, value: item.positionsId }))
					// 等待 DOM 刷新
					await this.$nextTick()
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiStaffQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiStaffQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiStaffQueryList()
			},
			//添加弹窗事件-开始
			birthdayAddChange(date, dateString) {
				this.addForm.birthday = dateString
			},
			entryTimeAddChange(date, dateString) {
				this.addForm.entryTime = dateString
			},
			birthdayEditChange(date, dateString) {
				this.editForm.birthday = dateString
			},
			entryTimeEditChange(date, dateString) {
				this.editForm.entryTime = dateString
			},

			tableAdd() {
				this.departmentList = []
				this.positionsList = []
				this.addVisible = true
			},
			enterpriseChange(e) {
				this.departmentList = []
				this.editForm.departmentId = 0
				this.addForm.departmentId = 0
				this.positionsList = []
				this.addForm.positions = []
				this.editForm.positions = []
				this.apiDepartmentList(e)
				// if(e == '0') {
					
				// } else {
					
				// }
			},
			async apiDepartmentList(enterpriseId) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDepartmentList, {enterpriseId: enterpriseId});
				if (res.code == 200) {
					this.departmentList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},

			async departmentChange(e) {
				this.positionsList = []
				this.addForm.positions = []
				this.editForm.positions = []
				if(e > 0) {
					await this.apiPositionsList(e)
				}
			},
			
			async apiStaffAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiStaffQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				// console.log(this.addForm)
				// return
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiStaffAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			async edit(item){
				console.log(item)
				let items = JSON.parse(JSON.stringify(item))
				// 处理职位数据
				if(items.positions) {
					items.positions = JSON.parse(items.positions)
				} else {
					items.positions = []
				}
				this.editForm = items
				// 加载部门列表
				if(items.enterpriseId) {
					await this.apiDepartmentList(items.enterpriseId)
				}
				if(items.departmentId){
					await this.apiPositionsList(items.departmentId)
				}
				this.editVisible = true
			},
			async apiStaffEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.editRuleForm) {
						this.$refs.editRuleForm.resetFields();
					}
					this.apiStaffQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiStaffEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.departmentId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.departmentName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiDepartmentDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiDepartmentDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDepartmentDel, {departmentId: this.tableSelectedRows.departmentId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiStaffQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.staffId > 0) {
					const item = this.tableData.find(item => item.staffId == this.tableSelectedRows.staffId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiEnterpriseList()
			this.apiStaffQueryList()
			// this.apiPositionsList()
		}
	};
</script>

<style scoped>

</style>
